interface Props {
  user: string;
  role: 'admin' | 'viewer';
  onLogout: () => void;
  onRefresh: () => void;
  disabled: boolean;
}

export default function ControlBar({ user, role, onLogout, onRefresh, disabled }: Props) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl bg-white p-4 shadow">
      <div className="flex items-center gap-2 text-sm">
        <span className="text-slate-700">Signed in as</span>
        <span className="font-medium text-slate-900">{user}</span>
        <span className="text-xs uppercase text-sky-700">{role}</span>
      </div>
      <div className="flex items-center gap-2">
        <button className="btn bg-slate-100 text-slate-700 hover:bg-slate-200" onClick={onRefresh} disabled={disabled}>
          Refresh
        </button>
        <button className="btn bg-slate-100 text-slate-700 hover:bg-slate-200" onClick={onLogout}>
          Log out
        </button>
      </div>
    </div>
  );
}
